import styled from "@emotion/styled";
import { MobileTitleContainer } from "./components/Facets/Facets.styled";

export {
  ContentGrid,
  GridWrapper,
  CategoryTreeWrapper,
  HeaderSortWrapper,
  StickyTitleContainer,
  ResultChip,
} from "src/atoms/PLPGrid";

export { ContentGrid as ProductListContentGrid } from "src/atoms/PLPGrid";

export const MobileCategoryPillsWrapper = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    display: block;
    grid-column: 1 / -1;
    /* Allow the scrolling pill row to shrink within the grid instead of
       forcing the column (and the page) wider than the viewport. */
    min-width: 0;
    max-width: 100%;
    ${MobileTitleContainer} + &:not(:empty) {
      margin-block-start: 12px;
    }
  }
`;

export const ProductGridContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 3;
  min-width: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints?.md}) {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: max-content max-content auto;
  }

  &.hideCategoryTree {
    grid-column: span 4;
  }
`;

export const ListingContainer = styled.div`
  /* CnstrcListingMarker sits in between as \`display: contents\`, so this is the
     real grid item of the PLP container and has to place itself. */
  grid-column: content;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-block-end: ${({ theme }) => theme.space.space48};
`;

export const PromoWrapper = styled.div`
  transition: all 250ms ease-in-out;
`;

export const NoResultsWrapper = styled.div`
  grid-column: span 3;
`;

export const PromotionBlockSkeletonWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors?.tone.white};
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.space?.space24};
  margin-block-end: ${({ theme }) => theme.space.space8};
`;

export const StyledAuthBanner = styled.div<{ hideCategoryTree?: boolean }>`
  grid-column: span 2;

  @media (min-width: ${({ theme }) => theme.breakpoints?.sm}) {
    grid-column: ${({ hideCategoryTree }) =>
      hideCategoryTree ? "span 4" : "span 3"};
  }
`;

export const HeaderContainer = styled.div`
  &.no-margin {
    @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
      margin-inline: -${({ theme }) => theme.space?.space16};
    }
  }
`;

export const PaginationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  place-items: center;
  justify-content: center;
  row-gap: ${({ theme }) => theme.space?.space48};
  margin-block-start: ${({ theme }) => theme.space?.space16};
  margin-block-end: ${({ theme }) => theme.space?.space24};

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    row-gap: ${({ theme }) => theme.space?.space32};
    margin-block-start: ${({ theme }) => theme.space?.space8};
    margin-block-end: ${({ theme }) => theme.space?.space8};
  }

  &.no-padding-plp {
    margin-block-end: ${({ theme }) => theme.space?.space48};

    @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
      margin-block-end: ${({ theme }) => theme.space?.space32};
    }
  }
`;
